import { Controller } from '@hotwired/stimulus';

// Counts down against a wall-clock target (not by decrementing on each tick) so the timer stays
// accurate under interval drift and background-tab throttling. The seconds are drawn in an
// aria-hidden span, so a screen reader is not told every second; the `status` span says once,
// when the button is ready again, and clears itself so the button's name goes back to its label.
const TICK_MS = 250;
const ANNOUNCEMENT_MS = 2000;

export default class extends Controller {
  static targets = ['countdown', 'status'];

  static values = {
    seconds: Number
  };

  connect() {
    this.targetAt = Date.now() + Math.max(0, this.secondsValue) * 1000;
    this.renderedSeconds = null;
    this.update();
    if (this.remaining() > 0) {
      this.interval = setInterval(() => this.update(), TICK_MS);
    }
  }

  disconnect() {
    this.stop();
    clearTimeout(this.announcementTimer);
  }

  update() {
    const remaining = this.remaining();

    if (remaining <= 0) {
      this.stop();
      this.complete();
      return;
    }

    this.render(remaining);
  }

  remaining() {
    return Math.max(0, Math.ceil((this.targetAt - Date.now()) / 1000));
  }

  render(remaining) {
    if (remaining === this.renderedSeconds) return;

    this.renderedSeconds = remaining;
    this.countdownTarget.textContent = `(${remaining}s)`;
  }

  complete() {
    this.element.removeAttribute('disabled');
    this.countdownTarget.textContent = '';
    this.statusTarget.textContent = 'Available again';
    this.announcementTimer = setTimeout(() => { this.statusTarget.textContent = ''; }, ANNOUNCEMENT_MS);
    this.dispatch('complete');
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
